<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table
          ref='table'
          :api-getlist="getList"
          :config="configIndex"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import configSite from './config_site.js'
import { getSiterequestList } from '@/api/siterequest'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      config,
      configSite
    }
  },
  watch: {
    protocol () {
      this.$refs.table.getData(true)
    }
  },  
  computed: {
    ...mapState(['user']),
    ...mapState('app', ['protocol']),
    configIndex () {
      if (this.user.role === 'Site') {
        return this.configSite
      }
      return this.config
    }
  },
  methods: {
    getList (entity, filters, pagination) {
      if (this.protocol.id !== -1) {
        filters.protocol_id = this.protocol.id
      }
      return getSiterequestList('siterequest', filters, pagination)
    }
  }
}
</script>
